/**
 * Represent an Observer registered to a given Observable object.
 */
var Observer = /** @class */ (function () {
    /**
     * Creates a new observer
     * @param next defines the callback to call when the observer is notified
     * @param notificationType defines what events the observer will receive (used to filter notifications)
     * @param value further optional filter that can restrict to a specific state or transition (node or edge).  Should not be used with NotifyOn.All
     */
    function Observer(
    /**
     * Defines the callback to call when the observer is notified
     */
    next, 
    /**
     * Defines the kind of notifications to subscribe for the observer (used to filter notifications)
     * default: All event types
     */
    notificationType, 
    /**
     * Further filter based on the values (should be used only when you have filtered specifically by state or transition - ie: not All)
     */
    valueFilter) {
        this.next = next;
        this.notificationType = notificationType;
        this.valueFilter = valueFilter;
        /** @hidden */
        this.willBeUnregistered = false;
        /**
         * Gets or sets a property defining that the observer as to be unregistered after the next notification
         */
        this.unregisterOnNextCall = false;
    }
    return Observer;
}());
export { Observer };
//# sourceMappingURL=Observer.js.map